import { combineReducers } from 'redux';

import authentication from './authentication';
import availableWidgets from './availableWidgets';
import reportSettings from './reportSettings';
import reportTemplate from './reportTemplate';
import reportTemplates from './reportTemplates';
import modal from './modal';
import saveState from './saveState';
import customers from './customers';
import tags from './tags';
import widgetEditor from './widgetEditor';
import widgetData from './widgetData';
import widgetUsageCounts from './widgetUsageCounts';

const rootReducer = combineReducers({
    authentication,
    availableWidgets,
    reportSettings,
    reportTemplate,
    reportTemplates,
    modal,
    saveState,
    customers,
    tags,
    widgetEditor,
    widgetData,
    widgetUsageCounts,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.ts